<template>
    <ideo-form-group :label="$t('[[[Aktualności ze strony]]]')" :invalid-feedback="form.$errors.first('settings.page')" :state="form.$errors.state('settings.page')" required>
        <edito-page-selector v-model="form.settings.page" :module="module" label="" :website="false" :preview="false" class="mb-0" />
    </ideo-form-group>
    <ideo-form-group :label="$t('[[[Zawierające jeden z wybranych tagów]]]')" :invalid-feedback="form.$errors.first('settings.tags')" :state="form.$errors.state('settings.tags')">
        <edito-tags v-model="form.settings.tags"></edito-tags>
    </ideo-form-group>
    <ideo-form-group>
        <ideo-form-checkbox v-model="form.settings.hasPriority">
            {{ $t('[[[Tylko priorytetowe]]]') }}
        </ideo-form-checkbox>
    </ideo-form-group>
    <ideo-form-group :label="$t('[[[Ilość wyświetlanych aktualności]]]')" :invalid-feedback="form.$errors.first('settings.quantity')" :state="form.$errors.state('settings.quantity')">
        <ideo-form-select name="settings.quantity" v-model="form.settings.quantity" :options="quantity"></ideo-form-select>
    </ideo-form-group>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Emit, Prop, Watch } from '@/helpers/Decorators';
import { Option } from '@/helpers/Interfaces';
import { FormType } from '@/helpers/Form';
import { ValidatableComponent } from '@/components/cms';
import merge from 'lodash/merge';

interface FormSettings
{
    settings: any;
}

@Options({
    name: 'widget-informations-settings'
})
export default class InformationsSettings extends Vue implements ValidatableComponent
{
    @Prop() public modelValue!: any;

    public module: string = 'informations';
    public defaults: any = {
        page: null,
        tags: [],
        hasPriority: false,
        quantity: 3
    };

    public get form(): FormType<FormSettings>
    {
        return this.modelValue;
    }

    public get quantity(): Option<number>[]
    {
        return new Array(10).fill(null).map((value, index) =>
        {
            return { value: index + 1, text: (index + 1).toString() };
        });
    }

    public async created(): Promise<void>
    {
        this.form.settings = merge(this.defaults, this.form.settings);
    }

    @Watch('form.settings', { deep: true })
    public onSettingsChanged(value: any): void
    {
        this.triggetModel();
    }

    @Emit('update:modelValue')
    public triggetModel(): any
    {
        return this.form;
    }

    public async validate(): Promise<void>
    {
        this.form.validate(schema => ({
            settings: schema.object({
                page: schema.string().nullable().required(this.$t('[[[Wybranie strony jest wymagane]]]'))
            })
        }));
    }
}
</script>
